import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
var moment = require('moment'); // require
export default class List extends Component {
  state = {}

  componentDidMount = () => {
    this.load()
  };

  load = () => {
    var rest = new Rest(this)
    rest.request("restaurants", "GET", {}, (res)=>{ 
      this.setState({
        data: res
      })
    })
  }

  delete = (id) => {
    var rest = new Rest(this)
    rest.request("restaurants", "DELETE", {id:id}, (res)=>{
      this.load()
    })
  }
  
  render() {
    console.log(this.state)
    return (
      <Container>
          <Row className="mt-3 mb-3">
            <Col>
                <h4>All restaurants of your company</h4>
            </Col>
          </Row>

          {
            this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
          }
          <Row>
              <Col>
                  <a className="btn btn-outline-primary m-1" href="/restaurants/create">Add restaurant</a>
                  <Table>
                      <thead>
                          <tr>
                              <th>ID</th>
                              <th>Weight</th> 
                              <th>Title</th>
                              <th>Status</th>
                          </tr>
                      </thead>
                      <tbody>
                          {
                            this.state.data && this.state.data.length && this.state.data.map(restaurant=>{
                              return (
                                <tr key={restaurant.id}>
                                  <td><a href={"/restaurants/edit/"+restaurant.id}>{restaurant.id} <FaPen size={13} title="edit" /></a> </td> 
                                  <td>{restaurant.weight}</td>
                                  <td>{restaurant.name}</td> 
                                  <td>{restaurant.status}</td> 
                                  <td><div className="text-danger pointer" onClick={()=>this.delete(restaurant.id)}><FaTrash size={13} title="edit"/> delete</div></td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                  </Table>
              </Col>
          </Row>
          
      </Container>
    );
  }
}
